const state = {
  listaTramitacoes: [],
  listaFluxos: [],
  listaDestinosFluxo: [],
  listaValidacaoFluxo: [],
  fluxoSelecionado: null,
  destinoSelecionado: null,
  despachoSelecionado: null,
  despachoSalvo: null,
  despachoFormatadoSelecionado: null,
  despachoFormatadoSalvo: null,
  nivelAcessoSelecionado: 'P',
  listaHipotesesLegais: [],
  hipoteseLegalSelecionada: null,
  tipoDespachoSelecionado: 'I',
  despachoPreparatorio: null
}

export default state
